export default __webpack_public_path__ + "static/media/overcast.84b6c674.png";